import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { apiService } from 'src/utils/apiServices';

const AuthContext = createContext();
const AuthActionsContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [admins, setAdmins] = useState([]);

  const signIn = async (signInData) => {
    try {
      const response = await apiService.post('/admin/signin', signInData);
      const data = await response.data.access_token;
      localStorage.setItem('token', JSON.stringify(data));
      setToken(data);
    } catch (error) {
      console.error('Error signing in:', error);
      throw error;
    }
  };

  const getAllAdmins = async () => {
    try {
      const response = await apiService.get('/admin/all', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.data;
      setAdmins(data);
      return data;
    } catch (error) {
      console.error('Error fetching admins:', error);
      throw error;
    }
  };

  const signOut = () => {
    setToken(null);
    localStorage.removeItem('token');
  };

  const clearAdmin = async (id) => {
    try {
      const response = await apiService.post(`/admin/clear/${id}`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      return response;
    } catch (error) {
      console.error('Error clearing admin:', error);
      throw error;
    }
  };

  const authActionsValue = useMemo(
    () => ({
      signIn,
      signOut,
      getAllAdmins,
      clearAdmin,
    }),
    []
  );

  const authValue = useMemo(() => ({ token, admins }), [token, admins]);

  useEffect(() => {
    getAllAdmins();
  }, []);

  return (
    <AuthContext.Provider value={authValue}>
      <AuthActionsContext.Provider value={authActionsValue}>{children}</AuthActionsContext.Provider>
    </AuthContext.Provider>
  );
};

export const useAuthData = () => useContext(AuthContext);
export const useAuthActions = () => useContext(AuthActionsContext);

AuthProvider.propTypes = {
  children: PropTypes.element,
};
